import {FC} from "react";
import {SavedMatch, useApiCall} from "../../../lib/src/api";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const DeleteSavedMatchModal: FC<{ savedMatch: SavedMatch, reload: () => void }> = (props) => {
  const { telephone } = useApiCall(config)
  const archive = async () => {
    await telephone.delMatch(props.savedMatch.id)
    props.reload()
  }

  return <>
    <div>Wil je deze koppeling verwijderen? Doorgaan?</div>
    <ModalFooter text={'Verwijder'} onSubmit={archive} />
  </>
}